import React, { FC, memo } from 'react';
import s from './index.module.scss';

type Props = {
  children?: JSX.Element;
};

const FormItem: FC<Props> = props => {
  const { children } = props;

  return (
    <div className={s.formItem }>
      {children}
    </div>
  );
};

export default memo(FormItem);
